import { emTransitoInadimplenciaStyles } from './EmTransitoInadimplencia.style'

export function emTransitoInadimplenciaIO() {
  return {
    styles: emTransitoInadimplenciaStyles
  }
}

export type EmTransitoInadimplenciaIO = ReturnType<typeof emTransitoInadimplenciaIO>
